const MAX_DISPLAY_RESPONSE_LENGTH = 200;

const looksLikeHtml = (value: string) => {
  const trimmed = value.trimStart().toLowerCase();
  return (
    trimmed.startsWith("<!doctype") ||
    trimmed.startsWith("<html") ||
    trimmed.includes("<title>") ||
    trimmed.includes("<body")
  );
};

/**
 * Shorten oversized / HTML remote responses for UI display.
 * "Something went wrong" is only used for failed tests.
 */
export const sanitizeTestResponseMessage = (
  responseMessage?: string | null,
  options?: { isError?: boolean },
): string | undefined => {
  if (!responseMessage) return undefined;

  const trimmed = responseMessage.trim();
  if (!trimmed) return undefined;

  const isUnreadable = looksLikeHtml(trimmed) || trimmed.length > MAX_DISPLAY_RESPONSE_LENGTH;

  if (isUnreadable) {
    return options?.isError ? "Something went wrong" : undefined;
  }

  return trimmed;
};

export const buildTestResultDisplayMessage = (
  test: {
    testStatus?: string | null;
    httpStatusCode?: number | null;
    responseMessage?: string | null;
    responseTimeMs?: number | null;
  },
  options?: { fallbackWhenMissing?: string },
) => {
  if (!test) return options?.fallbackWhenMissing ?? "No test result";

  const ok = (test.testStatus || "").toUpperCase() === "SUCCESS";
  const statusLabel = ok ? "Verified" : "Failed";
  const code = test.httpStatusCode ?? "—";
  const ms = test.responseTimeMs ?? 0;
  const detail = sanitizeTestResponseMessage(test.responseMessage, {
    isError: !ok,
  });

  return `${statusLabel} · ${code} · ${ms}ms${detail ? ` · ${detail}` : ""}`;
};
